import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * A premium, animated pagination component using Framer Motion.
 * Adapted to Vanilla CSS from the Morphing Page Dots design.
 */
export const MorphingPageDots = ({ 
  total, 
  activeIndex, 
  onChange 
}) => {
  const goPrev = () => {
    if (activeIndex > 0) onChange(activeIndex); // Note: activeIndex is 1-based in UserManagement
    // Adjusting for the 1-based index used in the app
    if (activeIndex > 1) onChange(activeIndex - 1);
  };

  const goNext = () => {
    if (activeIndex < total) onChange(activeIndex + 1);
  };

  return (
    <div className="morphing-pagination-container">
      {/* Left Arrow */}
      <button
        onClick={goPrev}
        className={`morphing-arrow-btn ${activeIndex === 1 ? "is-disabled" : ""}`}
        disabled={activeIndex === 1}
      >
        <ChevronLeft size={24} />
      </button>

      {/* Dots Container */}
      <div className="morphing-dots-area">
        {Array.from({ length: total }).map((_, i) => {
          const pageNum = i + 1;
          const isActive = pageNum === activeIndex;
          
          return (
            <motion.div
              key={i}
              className={`morphing-dot ${isActive ? "is-active" : ""}`}
              onClick={() => onChange(pageNum)}
              animate={{
                width: isActive ? 28 : 10,
                height: 10,
              }}
              transition={{ type: "spring", stiffness: 300, damping: 24 }}
            >
              {/* Ripple effect for active dot */}
              {isActive && (
                <AnimatePresence>
                  <motion.span
                    key="ripple"
                    className="morphing-dot-ripple"
                    initial={{ scale: 0.8, opacity: 0.6 }}
                    animate={{ scale: 1.6, opacity: 0 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.6 }}
                  />
                </AnimatePresence>
              )}
            </motion.div>
          );
        })}
      </div>

      {/* Right Arrow */}
      <button
        onClick={goNext}
        className={`morphing-arrow-btn ${activeIndex === total ? "is-disabled" : ""}`}
        disabled={activeIndex === total}
      >
        <ChevronRight size={24} />
      </button>
    </div>
  );
};
